import { makeStyles } from "@fluentui/react-components";

const space0 = '0rem';
const space1 = '.25rem';
const space2 = '.5rem';
const space3 = '1rem';
const space4 = '2.5rem';
const space5 = '5rem';
const space6 = '10rem';
const space7 = '15rem';

const useStyles = makeStyles({
    paddingLeft0: {
        paddingInlineStart: space0
    },
    paddingLeft1: {
        paddingInlineStart: space1
    },
    paddingLeft2: {
        paddingInlineStart: space2
    },
    paddingLeft3: {
        paddingInlineStart: space3
    },
    paddingLeft4: {
        paddingInlineStart: space4
    },
    paddingLeft5: {
        paddingInlineStart: space5
    },
    paddingLeft6: {
        paddingInlineStart: space6
    },
    paddingLeft7: {
        paddingInlineStart: space7
    },
    paddingRight0: {
        paddingInlineEnd: space0
    },
    paddingRight1: {
        paddingInlineEnd: space1
    },
    paddingRight2: {
        paddingInlineEnd: space2
    },
    paddingRight3: {
        paddingInlineEnd: space3
    },
    paddingRight4: {
        paddingInlineEnd: space4
    },
    paddingRight5: {
        paddingInlineEnd: space5
    },
    paddingRight6: {
        paddingInlineEnd: space6
    },
    paddingRight7: {
        paddingInlineEnd: space7
    },
    paddingTop0: {
        paddingBlockStart: space0
    },
    paddingTop1: {
        paddingBlockStart: space1
    },
    paddingTop2: {
        paddingBlockStart: space2
    },
    paddingTop3: {
        paddingBlockStart: space3
    },
    paddingTop4: {
        paddingBlockStart: space4
    },
    paddingTop5: {
        paddingBlockStart: space5
    },
    paddingTop6: {
        paddingBlockStart: space6
    },
    paddingTop7: {
        paddingBlockStart: space7
    },
    paddingBottom0: {
        paddingBlockEnd: space0
    },
    paddingBottom1: {
        paddingBlockEnd: space1
    },
    paddingBottom2: {
        paddingBlockEnd: space2
    },
    paddingBottom3: {
        paddingBlockEnd: space3
    },
    paddingBottom4: {
        paddingBlockEnd: space4
    },
    paddingBottom5: {
        paddingBlockEnd: space5
    },
    paddingBottom6: {
        paddingBlockEnd: space6
    },
    paddingBottom7: {
        paddingBlockEnd: space7
    },
    marginLeft1: {
        marginInlineStart: space1
    },
    marginLeft2: {
        marginInlineStart: space2
    },
    marginLeft3: {
        marginInlineStart: space3
    },
    marginLeft4: {
        marginInlineStart: space4
    },
    marginLeft5: {
        marginInlineStart: space5
    },
    marginLeft6: {
        marginInlineStart: space6
    },
    marginLeft7: {
        marginInlineStart: space7
    },
    marginRight1: {
        marginInlineEnd: space1
    },
    marginRight2: {
        marginInlineEnd: space2
    },
    marginRight3: {
        marginInlineEnd: space3
    },
    marginRight4: {
        marginInlineEnd: space4
    },
    marginRight5: {
        marginInlineEnd: space5
    },
    marginRight6: {
        marginInlineEnd: space6
    },
    marginRight7: {
        marginInlineEnd: space7
    },
    marginTop1: {
        marginBlockStart: space1
    },
    marginTop2: {
        marginBlockStart: space2
    },
    marginTop3: {
        marginBlockStart: space3
    },
    marginTop4: {
        marginBlockStart: space4
    },
    marginTop5: {
        marginBlockStart: space5
    },
    marginTop6: {
        marginBlockStart: space6
    },
    marginTop7: {
        marginBlockStart: space7
    },
    marginBottom1: {
        marginBlockEnd: space1
    },
    marginBottom2: {
        marginBlockEnd: space2
    },
    marginBottom3: {
        marginBlockEnd: space3
    },
    marginBottom4: {
        marginBlockEnd: space4
    },
    marginBottom5: {
        marginBlockEnd: space5
    },
    marginBottom6: {
        marginBlockEnd: space6
    },
    marginBottom7: {
        marginBlockEnd: space7
    },
});

export const useSpacingUtilities = () => {

    const styles = useStyles();

    const getSpacingClasses = (padding?: string, margin?: string): string[] => {
        const classNames: string[] = [];

        const paddings = padding?.split(' ');
        paddings?.forEach(pad => {
            pad == 'pl-0' && classNames.push(styles.paddingLeft0);
            pad == 'pl-1' && classNames.push(styles.paddingLeft1);
            pad == 'pl-2' && classNames.push(styles.paddingLeft2);
            pad == 'pl-3' && classNames.push(styles.paddingLeft3);
            pad == 'pl-4' && classNames.push(styles.paddingLeft4);
            pad == 'pl-5' && classNames.push(styles.paddingLeft5);
            pad == 'pl-6' && classNames.push(styles.paddingLeft6);
            pad == 'pl-7' && classNames.push(styles.paddingLeft7);

            pad == 'pr-0' && classNames.push(styles.paddingRight0);
            pad == 'pr-1' && classNames.push(styles.paddingRight1);
            pad == 'pr-2' && classNames.push(styles.paddingRight2);
            pad == 'pr-3' && classNames.push(styles.paddingRight3);
            pad == 'pr-4' && classNames.push(styles.paddingRight4);
            pad == 'pr-5' && classNames.push(styles.paddingRight5);
            pad == 'pr-6' && classNames.push(styles.paddingRight6);
            pad == 'pr-7' && classNames.push(styles.paddingRight7);

            pad == 'px-0' && classNames.push(styles.paddingLeft0, styles.paddingRight0);
            pad == 'px-1' && classNames.push(styles.paddingLeft1, styles.paddingRight1);
            pad == 'px-2' && classNames.push(styles.paddingLeft2, styles.paddingRight2);
            pad == 'px-3' && classNames.push(styles.paddingLeft3, styles.paddingRight3);
            pad == 'px-4' && classNames.push(styles.paddingLeft4, styles.paddingRight4);
            pad == 'px-5' && classNames.push(styles.paddingLeft5, styles.paddingRight5);
            pad == 'px-6' && classNames.push(styles.paddingLeft6, styles.paddingRight6);
            pad == 'px-7' && classNames.push(styles.paddingLeft7, styles.paddingRight7);

            pad == 'pt-0' && classNames.push(styles.paddingTop0);
            pad == 'pt-1' && classNames.push(styles.paddingTop1);
            pad == 'pt-2' && classNames.push(styles.paddingTop2);
            pad == 'pt-3' && classNames.push(styles.paddingTop3);
            pad == 'pt-4' && classNames.push(styles.paddingTop4);
            pad == 'pt-5' && classNames.push(styles.paddingTop5);
            pad == 'pt-6' && classNames.push(styles.paddingTop6);
            pad == 'pt-7' && classNames.push(styles.paddingTop7);

            pad == 'pb-0' && classNames.push(styles.paddingBottom0);
            pad == 'pb-1' && classNames.push(styles.paddingBottom1);
            pad == 'pb-2' && classNames.push(styles.paddingBottom2);
            pad == 'pb-3' && classNames.push(styles.paddingBottom3);
            pad == 'pb-4' && classNames.push(styles.paddingBottom4);
            pad == 'pb-5' && classNames.push(styles.paddingBottom5);
            pad == 'pb-6' && classNames.push(styles.paddingBottom6);
            pad == 'pb-7' && classNames.push(styles.paddingBottom7);

            pad == 'py-0' && classNames.push(styles.paddingTop0, styles.paddingBottom0);
            pad == 'py-1' && classNames.push(styles.paddingTop1, styles.paddingBottom1);
            pad == 'py-2' && classNames.push(styles.paddingTop2, styles.paddingBottom2);
            pad == 'py-3' && classNames.push(styles.paddingTop3, styles.paddingBottom3);
            pad == 'py-4' && classNames.push(styles.paddingTop4, styles.paddingBottom4);
            pad == 'py-5' && classNames.push(styles.paddingTop5, styles.paddingBottom5);
            pad == 'py-6' && classNames.push(styles.paddingTop6, styles.paddingBottom6);
            pad == 'py-7' && classNames.push(styles.paddingTop7, styles.paddingBottom7);
        });

        const margins = margin?.split(' ');
        margins?.forEach(marg => {
            marg == 'ml-1' && classNames.push(styles.marginLeft1);
            marg == 'ml-2' && classNames.push(styles.marginLeft2);
            marg == 'ml-3' && classNames.push(styles.marginLeft3);
            marg == 'ml-4' && classNames.push(styles.marginLeft4);
            marg == 'ml-5' && classNames.push(styles.marginLeft5);
            marg == 'ml-6' && classNames.push(styles.marginLeft6);
            marg == 'ml-7' && classNames.push(styles.marginLeft7);
            marg == 'mr-1' && classNames.push(styles.marginRight1);
            marg == 'mr-2' && classNames.push(styles.marginRight2);
            marg == 'mr-3' && classNames.push(styles.marginRight3);
            marg == 'mr-4' && classNames.push(styles.marginRight4);
            marg == 'mr-5' && classNames.push(styles.marginRight5);
            marg == 'mr-6' && classNames.push(styles.marginRight6);
            marg == 'mr-7' && classNames.push(styles.marginRight7);
            marg == 'mx-1' && classNames.push(styles.marginLeft1, styles.marginRight1);
            marg == 'mx-2' && classNames.push(styles.marginLeft2, styles.marginRight2);
            marg == 'mx-3' && classNames.push(styles.marginLeft3, styles.marginRight3);
            marg == 'mx-4' && classNames.push(styles.marginLeft4, styles.marginRight4);
            marg == 'mx-5' && classNames.push(styles.marginLeft5, styles.marginRight5);
            marg == 'mx-6' && classNames.push(styles.marginLeft6, styles.marginRight6);
            marg == 'mx-7' && classNames.push(styles.marginLeft7, styles.marginRight7);

            marg == 'mt-1' && classNames.push(styles.marginTop1);
            marg == 'mt-2' && classNames.push(styles.marginTop2);
            marg == 'mt-3' && classNames.push(styles.marginTop3);
            marg == 'mt-4' && classNames.push(styles.marginTop4);
            marg == 'mt-5' && classNames.push(styles.marginTop5);
            marg == 'mt-6' && classNames.push(styles.marginTop6);
            marg == 'mt-7' && classNames.push(styles.marginTop7);
            marg == 'mb-1' && classNames.push(styles.marginBottom1);
            marg == 'mb-2' && classNames.push(styles.marginBottom2);
            marg == 'mb-3' && classNames.push(styles.marginBottom3);
            marg == 'mb-4' && classNames.push(styles.marginBottom4);
            marg == 'mb-5' && classNames.push(styles.marginBottom5);
            marg == 'mb-6' && classNames.push(styles.marginBottom6);
            marg == 'mb-7' && classNames.push(styles.marginBottom7);
            marg == 'my-1' && classNames.push(styles.marginTop1, styles.marginBottom1);
            marg == 'my-2' && classNames.push(styles.marginTop2, styles.marginBottom2);
            marg == 'my-3' && classNames.push(styles.marginTop3, styles.marginBottom3);
            marg == 'my-4' && classNames.push(styles.marginTop4, styles.marginBottom4);
            marg == 'my-5' && classNames.push(styles.marginTop5, styles.marginBottom5);
            marg == 'my-6' && classNames.push(styles.marginTop6, styles.marginBottom6);
            marg == 'my-7' && classNames.push(styles.marginTop7, styles.marginBottom7);
        });

        return classNames;
    }

    return {
        getSpacingClasses,
    };
}